import Svg, { Path } from 'react-native-svg';
import Colors from 'src/core/utils/Colors';
import Dimens from 'src/core/utils/Dimens';

interface Props {
	width?: number;
	height?: number;
	outlineColor?: string;
	sparkleColor?: string;
}

export default ({
	width = Dimens.iconSize30,
	height = Dimens.iconSize30,
	outlineColor = Colors.green,
	sparkleColor = Colors.goldLight,
}: Props) => (
	<Svg height={height} viewBox="0 0 25.079 29.227" width={width}>
		<Path
			d="m12.307 19.743-6.512 3.423a.5.5 0 0 1-.726-.527l1.244-7.25a.5.5 0 0 0-.144-.443L.901 9.81a.5.5 0 0 1 .277-.852L8.458 7.9a.5.5 0 0 0 .377-.274l3.256-6.597a.5.5 0 0 1 .897 0l3.256 6.597a.5.5 0 0 0 .376.274l7.28 1.058a.5.5 0 0 1 .278.852l-5.269 5.136a.5.5 0 0 0-.143.442l1.243 7.251a.5.5 0 0 1-.725.527l-6.512-3.423a.5.5 0 0 0-.465 0Z"
			fill={Colors.white}
		/>
		<Path
			d="M11.418.697a1.25 1.25 0 0 1 2.242 0l3.197 6.478 7.151 1.04a1.25 1.25 0 0 1 1.07 1.29l-.012.127a1.25 1.25 0 0 1-.365.716l-5.175 5.043 1.222 7.121a1.25 1.25 0 0 1-.895 1.416l-.125.028a1.25 1.25 0 0 1-.793-.126l-6.396-3.362-6.395 3.362a1.25 1.25 0 0 1-1.618-.407l-.07-.118a1.25 1.25 0 0 1-.126-.793l1.221-7.121-5.173-5.043a1.25 1.25 0 0 1-.113-1.665l.09-.103a1.25 1.25 0 0 1 .715-.365l7.15-1.04L11.418.697Zm1.121 1.119L9.508 7.958a1.25 1.25 0 0 1-.942.684l-6.779.985 4.906 4.782c.262.255.397.61.375.97l-.016.136-1.158 6.75 6.064-3.186a1.25 1.25 0 0 1 1.023-.063l.14.063 6.062 3.187-1.157-6.751a1.25 1.25 0 0 1 .268-1.006l.092-.1 4.904-4.783-6.778-.984a1.25 1.25 0 0 1-.874-.565l-.067-.119-3.032-6.143Z"
			fill={outlineColor}
			fillRule="nonzero"
		/>
		<Path
			d="m9.675 24.014.97.243-.12.485-1 4-.122.485-.97-.243.121-.485 1-4zM14.403 24.014l.121.485 1 4 .121.485-.97.242-.12-.484-1-4-.122-.485z"
			fill={sparkleColor}
			fillRule="nonzero"
		/>
	</Svg>
);
